import {
  distributedCents,
  emptyParticipant,
  moneyCents,
  participantAmount,
} from './salesCommissionForm';

export const GROUP_CATALOG_KEYS = {
  general_managers: 'gerentes_gerais',
  managers: 'gerentes',
  seller_brokers: 'corretores',
  optionist_brokers: 'corretores',
};

export const payerOptionsFromParticipants = participants => {
  const options = (Array.isArray(participants) ? participants : []).filter(
    participant =>
      ['vendedor', 'comprador'].includes(participant.role) &&
      participant.relation_type === 'principal' &&
      participant.status !== 'removed'
  );
  return options.filter(
    (option, index, source) =>
      source.findIndex(item => String(item.id) === String(option.id)) === index
  );
};

export const resizedPayers = (installment, count) => {
  const size = Math.max(1, Math.min(20, Number(count) || 1));
  const total = moneyCents(installment.amount);
  const amounts = distributedCents(total, size);
  return Array.from({ length: size }, (_, index) => {
    return {
      ...(installment.payers[index] || {}),
      user_id: installment.payers[index]?.user_id || '',
      name: installment.payers[index]?.name || '',
      amount: (amounts[index] / 100).toFixed(2),
    };
  });
};

export const resizedParticipants = (group, count) => {
  const size = Math.max(0, Math.min(20, Number(count) || 0));
  return Array.from(
    { length: size },
    (_, index) => group.rows[index] || emptyParticipant()
  );
};

export const evenlyDistributedPercentages = count => {
  const size = Math.max(1, Math.min(20, Number(count) || 1));
  const base = Math.floor(100 / size);
  const last = Math.ceil(100 / size);
  return Array.from({ length: size }, (_, index) =>
    String(index === size - 1 ? last : base)
  );
};

export const participantsWithDistributedPercentages = ({
  rows,
  netCents,
  totalPercentage,
}) => {
  const percentages = evenlyDistributedPercentages(rows.length);
  return rows.map((row, index) => ({
    ...row,
    percentage: percentages[index],
    amount: participantAmount(netCents, totalPercentage, percentages[index]),
  }));
};

export const participantWithSelection = ({
  row,
  options,
  netCents,
  totalPercentage,
  field,
  value,
}) => {
  const selected =
    field === 'user_id'
      ? options.find(option => String(option.id) === String(value))
      : null;
  const next = {
    ...row,
    ...(selected
      ? {
          ...selected,
          user_id: selected.usuario_id || selected.id,
          name: selected.name || selected.label,
        }
      : {}),
    [field]: value,
  };
  next.amount = participantAmount(netCents, totalPercentage, next.percentage);
  return next;
};
